const mediaData = [
  {
    title: '本周精选：动作片特辑',
    desc: '精选十部高分动作片，从港式武打到好莱坞大片，肾上腺素飙升的观影体验',
    duration: '12部推荐',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20movie%20scene%20with%20intense%20car%20chase%20and%20explosions%2C%20warm%20golden%20hour%20lighting%2C%20cinematic%20composition%2C%20dark%20urban%20backdrop%2C%20dramatic%20lighting%20with%20lens%20flares%2C%20professional%20movie%20cinematography%2C%20high%20contrast%2C%20film%20grain%20texture%2C%20epic%20scale&width=800&height=500&seq=wukong-media-01&orientation=landscape'
  },
  {
    title: '喜剧片合集：笑到停不下来',
    desc: '最新上线的喜剧佳作合集，涵盖国产喜剧、黑色幽默、合家欢喜剧等多种风格',
    duration: '8部推荐',
    img: 'https://readdy.ai/api/search-image?query=Bright%20and%20colorful%20comedy%20film%20scene%2C%20funny%20expressions%20and%20joyful%20atmosphere%2C%20warm%20lighting%20with%20soft%20shadows%2C%20cozy%20indoor%20setting%20with%20vibrant%20decor%2C%20cinematic%20photography%20style%2C%20lighthearted%20mood%2C%20professional%20color%20grading%2C%20clean%20composition&width=800&height=500&seq=wukong-media-02&orientation=landscape'
  },
  {
    title: '科幻巨制：视觉盛宴',
    desc: '顶级的科幻大作一次看够，震撼的视觉特效与深刻的科幻主题，满足科幻迷的所有期待',
    duration: '10部推荐',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20cityscape%20with%20neon%20lights%20and%20floating%20structures%2C%20deep%20space%20background%20with%20stars%2C%20dramatic%20cinematic%20lighting%2C%20cool%20and%20warm%20color%20contrast%2C%20epic%20scale%2C%20professional%20movie%20visual%20effects%20aesthetic%2C%20clean%20minimalist%20composition&width=800&height=500&seq=wukong-media-03&orientation=landscape'
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-play-circle-line text-2xl text-primary-500"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 font-bold">
            精选推荐
          </h2>
        </div>
        <p className="text-sm text-foreground-400 mb-8 md:mb-10 ml-11">
          悟空影视编辑团队为您精选的高分影片合集
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaData.map((item, idx) => (
            <div
              key={idx}
              className="rounded-lg overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-500/30 transition-all duration-300 cursor-pointer group"
            >
              <div className="relative w-full h-[200px] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/70 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <div className="w-10 h-10 rounded-full bg-primary-500/90 flex items-center justify-center cursor-pointer">
                    <i className="ri-play-fill text-white text-lg ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="px-2 py-1 text-[10px] font-medium rounded bg-background-50/80 backdrop-blur-sm text-foreground-300 whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-200 group-hover:text-primary-400 transition-colors mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}